import axios from 'axios';
import {
    observable
} from 'mobx';

// 文章

const initial = {
    list: []
}

export default class Arc {
    @observable datas = initial;

    getList() {
        axios.get('./static/mock/arc.json').then(j => {
            this.datas.list = j.data.data || []
        }).catch(e => console.log(e))
    }
}